import { getCurrentLocale } from '@/helpers/i18n';
import { formatHash as formatHashUtil } from '@dormakaba/utils';

export const formatHash = (value: string, withHash?: boolean): string => {
  return formatHashUtil(value, withHash, getCurrentLocale());
};
